import React, { useEffect, useRef, useState } from "react";
import {
  getBranchDetails,
  getOrderDetails,
  getOrgDetails,
  getUserFromUidx,
  getRetailDetailsByBranch,
} from "../../../../../config/Services";
import {
  Br,
  Cut,
  Line,
  Printer,
  Text,
  Row,
  Image,
  Barcode,
  QRCode,
  render,
  Cashdraw,
} from "react-thermal-printer";
import { transforms } from "@react-thermal-printer/image";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { emit } from "react-native-react-bridge/lib/web";
import { useSelector } from "react-redux";
import { getMobilePos } from "../redux/Reducers/paginationReducer";
import recycleLogo from "../../../../../assets/images/recycle_logo3.svg";
import { useSnackbar } from "../../hooks/SnackbarProvider";

export const Print = ({ orderId, print, setPrint, drawerOpen, reprint } = {}) => {
  const buttonRef = useRef(null);
  const navigate = useNavigate();
  const [baseOrderResponse, setBaseOrderResponse] = useState([]);
  const [baseDetails, setBaseDetails] = useState({});
  const [gstBreakupDetails, setGstBreakupDetails] = useState([]);
  const [orderDetails, setOrderDetails] = useState({});
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [orgDetails, setOrgDetails] = useState([]);
  const [branchDetails, setbranchDetails] = useState([]);
  const [noGst, setNoGst] = useState([]);
  const [gst2slab, setGst2slab] = useState([]);
  const [gst5slab, setGst5slab] = useState([]);
  const [gst6slab, setGst6slab] = useState([]);
  const [gst9slab, setGst9slab] = useState([]);
  const [gst14slab, setGst14slab] = useState([]);
  const [loggedUser, setLoggedUser] = useState("");
  const [date, setDate] = useState("");
  const [invoiceId, setInvoiceId] = useState("");
  const [retailDetails, setRetailDetails] = useState([]);
  const [isData, setIsData] = useState(false);
  const [portData, setPortData] = useState(null);
  const [reprintData, setReprintData] = useState(false);
  const isMobilePos = useSelector(getMobilePos);
  const mode = localStorage.getItem("mode");

  const [locationData, setLocationData] = useState(
    JSON.parse(localStorage.getItem("locationData"))
  );
  const [printerConfig, setPrinterConfig] = useState(
    JSON.parse(localStorage.getItem("printerConfig"))
  );
  const [retailUserDetails, setRetailUserDetails] = useState(
    JSON.parse(localStorage.getItem("retailUserDetails"))
  );

  const convertUTCDateToLocalDate = (dat) => {
    var date = moment.utc(dat).format("YYYY-MM-DD HH:mm:ss");
    var stillUtc = moment.utc(date).toDate();
    setDate(moment(stillUtc).local().format("L, LT"));
  };

  const fetchDetails = async () => {
    if (drawerOpen) {
      handleClick();
      return;
    }
    const rtBrId = localStorage.getItem("locId");
    getOrderDetails(orderId, rtBrId).then((response) => {
      setBaseOrderResponse(response.data.data.baseOrderResponse);
      convertUTCDateToLocalDate(response.data.data.baseOrderResponse.createdAt);
      setInvoiceId(response.data.data.baseOrderResponse.invoiceId);
      setBaseDetails(response.data.data.orderBillingDetails);
      setGstBreakupDetails(response.data.data.gstBreakupDetails);
      setOrderDetails(response.data.data.orderBillingDetails);
      setNoGst(response.data.data.gstWiseOrderItems["No Gst slab"] || []);
      setGst2slab(response.data.data.gstWiseOrderItems["2.5 cgst and 2.5 sgst slab"] || []);
      setGst5slab(response.data.data.gstWiseOrderItems["5 cgst and 5 sgst slab"] || []);
      setGst6slab(response.data.data.gstWiseOrderItems["6 cgst and 6 sgst slab"] || []);
      setGst9slab(response.data.data.gstWiseOrderItems["9 cgst and 9 sgst slab"] || []);
      setGst14slab(response.data.data.gstWiseOrderItems["14 cgst and 14 sgst slab"] || []);
      setGstBreakupDetails(response.data.data.gstBreakupDetails);
      setTotalQuantity(
        response?.data?.data?.baseOrderResponse?.orderItemList
          ?.map((item) => item.quantity)
          .reduce((a, b) => a + b, 0)
      );
      const getLocationData = async () => {
        if (!locationData) {
          try {
            const response = await getRetailDetailsByBranch(rtBrId);
            if (response?.data?.data) {
              localStorage.setItem("locationData", JSON.stringify(response?.data?.data));
              setRetailDetails(response.data.data);
            }
          } catch (e) {}
        } else {
          setRetailDetails(locationData);
        }
      };
      retailUserDetails
        ? getLocationData().then(() => {
            setLoggedUser(`${retailUserDetails.firstName} ${retailUserDetails.secondName}`);
          })
        : getLocationData().then(() => {
            getUserFromUidx(response.data.data.baseOrderResponse?.loggedInUserId).then(
              async (res) => {
                setLoggedUser(res.data.data.firstName + " " + res.data.data.secondName);
              }
            );
          });
    });
    setIsData(true);
    // await printSerial()
  };

  // const openPort = async () => {
  // const port = await window.navigator.serial.requestPort();
  // await port.open({ baudRate: 115200 });
  // setPortData(port);
  // return port;
  // };

  const billData = async () => {
    if (drawerOpen) {
      return await render(
        <Printer type="epson" width={printerWidth}>
          <Cashdraw pin="2pin" />
        </Printer>
      );
    }
    const printerWidth = (await printerConfig?.printer) === "TVS" ? 46 : 42;
    return await render(
      <Printer type="epson" width={printerWidth}>
        {/* <Text align="center">Evernest Private Limited</Text>
        <Text align="center">Level 4, No 3, Narayani Arcade</Text>
        <Text align="center">ITPL Main Rd, Kundalahalli</Text>
        <Text align="center">Bengaluru, Karnataka 560037</Text>
        <Text align="center">Phone: +91 7558890052</Text>
        <Text align="center">GSTIN: 27AACCA8432H1ZQ</Text> */}

        <Text align="center" bold={true} size={{ width: 2, height: 2 }}>
          {retailDetails?.displayName || "Store Name"}
        </Text>
        <Text align="center">{retailDetails?.address?.addressLine1 || "AddressLine1"}</Text>

        <Text align="center">{retailDetails?.address?.addressLine2 || "AddressLine2"}</Text>

        <Text align="center">
          Phone:{" "}
          {`${
            retailDetails?.contacts?.map(({ phoneNo }) => phoneNo).join(" / ") || "PhoneNo"
          } GSTIN: ${retailDetails?.gst || "GSTIN"}`}
        </Text>

        <Line />
        <Text align="center" bold={true}>
          TAX INVOICE
        </Text>
        <Line />
        <Row left={`Bill No ${invoiceId}`} right={loggedUser} />
        <Row left={date.toLocaleString()} right={baseDetails.paymentMethod} />
        <Line />
        <Text bold={true}>{"HSN   Particulars".padEnd(42)}</Text>
        <Text bold={true}>{"             Qty    MRP     Rate     Value"}</Text>
        <Line />
        {noGst?.length && (
          <>
            <Text bold={true}>{"          No CGST + No SGST"}</Text>
            {noGst?.map((e) => (
              <>
                <Text>{`${e.hsnCode.slice(0, 4).padEnd(4)}  ${e.productName
                  .slice(0, 36)
                  .padEnd(36)}`}</Text>
                <Text>{`             ${(e?.returnedQuantity ?? e?.quantityBySpecs ?? e?.quantity)
                  .toString()
                  .slice(0, 3)
                  .padStart(3)}${e?.mrp.toString().slice(0, 7).padStart(7)}${e?.sellingPrice
                  .toString()
                  .slice(0, 9)
                  .padStart(9)} ${(e?.returnedSubTotal ?? e?.subTotal)
                  .toString()
                  .slice(0, 9)
                  .padStart(9)}`}</Text>
              </>
            ))}
          </>
        )}
        {gst2slab?.length && (
          <>
            <Text bold={true}>{"          2.5% CGST and 2.5% SGST"}</Text>
            {gst2slab?.map((e) => (
              <>
                <Text>{`${e.hsnCode.slice(0, 4).padEnd(4)}  ${e.productName
                  .slice(0, 36)
                  .padEnd(36)}`}</Text>
                <Text>{`             ${(e?.returnedQuantity ?? e?.quantityBySpecs ?? e?.quantity)
                  .toString()
                  .slice(0, 3)
                  .padStart(3)}${e.mrp.toString().slice(0, 7).padStart(7)}${e?.sellingPrice
                  .toString()
                  .slice(0, 9)
                  .padStart(9)} ${(e?.returnedSubTotal ?? e?.subTotal)
                  .toString()
                  .slice(0, 9)
                  .padStart(9)}`}</Text>
              </>
            ))}
          </>
        )}
        {gst5slab?.length && (
          <>
            <Text bold={true}>{"          5% CGST and 5% SGST"}</Text>
            {gst5slab?.map((e) => (
              <>
                <Text>{`${e.hsnCode.slice(0, 4).padEnd(4)}  ${e.productName
                  .slice(0, 36)
                  .padEnd(36)}`}</Text>
                <Text>{`             ${(e?.returnedQuantity ?? e?.quantityBySpecs ?? e?.quantity)
                  .toString()
                  .slice(0, 3)
                  .padStart(3)}${e?.mrp.toString().slice(0, 7).padStart(7)}${e?.sellingPrice
                  .toString()
                  .slice(0, 9)
                  .padStart(9)} ${(e?.returnedSubTotal ?? e.subTotal)
                  .toString()
                  .slice(0, 9)
                  .padStart(9)}`}</Text>
              </>
            ))}
          </>
        )}
        {gst6slab?.length && (
          <>
            <Text bold={true}>{"          6% CGST and 6% SGST"}</Text>
            {gst6slab?.map((e) => (
              <>
                <Text>{`${e.hsnCode.slice(0, 4).padEnd(4)}  ${e.productName
                  .slice(0, 36)
                  .padEnd(36)}`}</Text>
                <Text>{`             ${(e?.returnedQuantity ?? e?.quantityBySpecs ?? e?.quantity)
                  .toString()
                  .slice(0, 3)
                  .padStart(3)}${e?.mrp.toString().slice(0, 7).padStart(7)}${e?.sellingPrice
                  .toString()
                  .slice(0, 9)
                  .padStart(9)} ${(e?.returnedSubTotal ?? e?.subTotal)
                  .toString()
                  .slice(0, 9)
                  .padStart(9)}`}</Text>
              </>
            ))}
          </>
        )}
        {gst9slab?.length && (
          <>
            <Text bold={true}>{"          9% CGST and 9% SGST"}</Text>
            {gst9slab?.map((e) => (
              <>
                <Text>{`${e.hsnCode.slice(0, 4).padEnd(4)}  ${e.productName
                  .slice(0, 36)
                  .padEnd(36)}`}</Text>
                <Text>{`             ${(e?.returnedQuantity ?? e?.quantityBySpecs ?? e?.quantity)
                  .toString()
                  .slice(0, 3)
                  .padStart(3)}${e?.mrp.toString().slice(0, 7).padStart(7)}${e?.sellingPrice
                  .toString()
                  .slice(0, 9)
                  .padStart(9)} ${(e?.returnedSubTotal ?? e.subTotal)
                  .toString()
                  .slice(0, 9)
                  .padStart(9)}`}</Text>
              </>
            ))}
          </>
        )}
        {gst14slab?.length && (
          <>
            <Text bold={true}>{"          14% CGST and 14% SGST"}</Text>
            {gst14slab?.map((e) => (
              <>
                <Text>{`${e.hsnCode.slice(0, 4).padEnd(4)}  ${e.productName
                  .slice(0, 36)
                  .padEnd(36)}`}</Text>
                <Text>{`             ${(e?.returnedQuantity ?? e?.quantityBySpecs ?? e?.quantity)
                  .toString()
                  .slice(0, 3)
                  .padStart(3)}${e?.mrp.toString().slice(0, 7).padStart(7)}${e?.sellingPrice
                  .toString()
                  .slice(0, 9)
                  .padStart(9)} ${(e?.returnedSubTotal ?? e.subTotal)
                  .toString()
                  .slice(0, 9)
                  .padStart(9)}`}</Text>
              </>
            ))}
          </>
        )}
        <Line />
        <Row
          left={<Text>{`Redeemed Pts: ${orderDetails?.redeemedLoyaltyPoints || 0}`}</Text>}
          right={<Text>{`Redeemed Value: -${orderDetails?.loyaltyPointsValue || 0}`}</Text>}
        />
        <Row
          left={<Text>{`Earned Pts: ${orderDetails?.loyaltyPointsEarned || 0}`}</Text>}
          right={<Text>{`Coupons: -${orderDetails?.couponValue || 0}`}</Text>}
        />
        <Line />
        <Row
          left={
            <Text
              bold={true}
            >{`Items: ${baseOrderResponse?.orderItemList?.length}  Qty: ${totalQuantity}`}</Text>
          }
          right={<Text bold={true}>{`Total Amount: ${orderDetails?.grandTotal}`}</Text>}
        />
        <Line />
        {baseOrderResponse?.tender && (
          <Row
            left={<Text bold={true}>{`Tender: ${baseOrderResponse?.tender}`}</Text>}
            right={<Text bold={true}>{`Change: ${baseOrderResponse?.balance}`}</Text>}
          />
        )}

        {baseDetails.paymentMethod === "SPLIT" &&
          orderDetails?.payments.map((e) => <Text>{`${e.paymentMethod}: ${e.amountPaid}`}</Text>)}
        {/* <Row
          left={<Text bold={true}>{`Tender: ${baseOrderResponse?.tender}`}</Text>}
          right={<Text bold={true}>{`Change: ${baseOrderResponse?.balance}`}</Text>}
        /> */}
        <Line />
        <Text align="center" bold={true}>
          {"<--------- GST Breakup Details --------->"}
        </Text>
        <Line />
        <Text bold={true}>{"SNo   TaxableAmt    CGST   SGST   TotalAmt"}</Text>
        <Line />
        {gstBreakupDetails?.length &&
          gstBreakupDetails
            ?.filter((item) => item.taxableAmt != null)
            ?.map((e, i) => (
              <Text>{`${i + 1}     ${e.taxableAmt
                .toFixed(2)
                .toString()
                .slice(0, 10)
                .padEnd(10)}  ${e.cgst.toFixed(2).toString().slice(0, 6).padStart(6)}${e.sgst
                .toFixed(2)
                .toString()
                .slice(0, 7)
                .padStart(7)}${
                e.totalAmt ? e.totalAmt.toFixed(2).toString().slice(0, 11).padStart(11) : "---"
              }`}</Text>
            ))}
        <Line />
        <Text align="center" bold={true}>
          Items sold cannot be returned or refunded
        </Text>
        <Line character="=" />
        <Row
          left={
            <Text bold={true} size={{ width: 2, height: 2 }}>
              Total Savings
            </Text>
          }
          right={
            <Text bold={true} size={{ width: 2, height: 2 }}>{`${
              orderDetails.totalSavings || 0
            }`}</Text>
          }
        />
        <Line character="=" />
        <Text align="center" bold={true}>
          Please bring your own shopping bags and
        </Text>
        <Text align="center" bold={true}>
          Help Save Environment
        </Text>
        <Image align="center" src={recycleLogo} transforms={[transforms.floydSteinberg]} />
        <Text align="center">Thank you for shopping with us!</Text>
        <Text align="center">@Powered by Pallet</Text>
        {reprint ?? <Cashdraw pin="2pin" />}
        {/* <Text>text</Text>
        <Text>fragment is {"allowed"}</Text>
        <Text align="center">center text</Text>
        <Text align="right">right text</Text>
        <Text bold={true}>bold text</Text>
        <Text underline="1dot-thick">underline text</Text>
        <Text invert={true}>invert text</Text>
        <Text size={{ width: 2, height: 2 }}>big size text</Text>
        <Br />
        <Row left="left" right="right" />
        <Row left="left" right="right" gap={2} />
        <Row left={<Text>left</Text>} right="right" />
        <Row left={<Text>left</Text>} right="very very long text will be multi line placed." />
        <Br />
        <Line />
        <Line character="=" />
        <Br />
        <Barcode type="UPC-A" content="111111111111" />
        <Barcode type="CODE39" content="A000$" />
        <Barcode align="center" type="UPC-A" content="111111111111" />
        <Br />
        <QRCode content="https://github.com/seokju-na/react-thermal-printer" />
        <QRCode align="center" content="https://github.com/seokju-na/react-thermal-printer" />
        <Br /> */}
        <Cut />
      </Printer>
    );
  };

  const printSerial = async () => {
    // if (!portData) {
    //   await openPort();
    // }
    try {
      const prevPort = await navigator.serial.getPorts();
      const port = prevPort[0]?.readable
        ? prevPort[0]
        : await window.navigator.serial.requestPort();
      prevPort[0]?.readable
        ? console.log("Port already open")
        : await port.open({ baudRate: 115200 });

      const data = await billData();

      const writer = port.writable?.getWriter();
      if (writer != null) {
        await writer.write(new Uint8Array(data));
        writer.releaseLock();
      }
    } catch (error) {
      console.log(error);
    } finally {
      localStorage.removeItem("CartId");
      navigate(mode == "KEYPAD" ? "/grocery/cart" : "/products/all-products");
    }
  };

  const printUSB = async () => {
    try {
      const data = await billData();

      const findOpenedDevice = async () => {
        const devices = await navigator.usb.getDevices();
        return devices.find((d) => d.opened);
      };

      const openedDevice = await findOpenedDevice();

      const usbDevice =
        openedDevice ||
        (await navigator.usb.requestDevice({ filters: [{ vendorId: 3386 }, { vendorId: 5455 }] }));
      openedDevice ? console.log("Port already open") : await usbDevice.open();
      // const usbDevice = await navigator.usb.requestDevice({ filters: [{ vendorId: 3386 }] });
      // const usbDevice = await navigator.usb.requestDevice({ filters: [] });

      if (usbDevice.configuration === null) {
        await usbDevice.selectConfiguration(1);
      }
      await usbDevice.claimInterface(usbDevice.configuration.interfaces[0].interfaceNumber);

      await usbDevice.transferOut(
        usbDevice.configuration.interfaces[0].alternate.endpoints.find(
          (obj) => obj.direction === "out"
        ).endpointNumber,
        data
      );

      // You can now send commands to the printer
    } catch (error) {
      console.error("Error connecting to the printer: ", error);
    } finally {
      setPrint(null);
      if (drawerOpen || reprint) return;
    }
  };

  useEffect(() => {
    if (print === false) {
      fetchDetails();
    }
  }, [print]);

  useEffect(() => {
    if (loggedUser) {
      buttonRef.current.click();
    }
  }, [loggedUser]);

  const handleClick = async () => {
    printerConfig?.label === "USB port" ? await printUSB() : await printSerial();
  };

  return (
    <div>
      <button
        ref={buttonRef}
        onClick={handleClick}
        className="buttonClass"
        style={{ display: "none" }}
      ></button>
      {/* <button onClick={printSerial}>Print Serial</button>
      <button onClick={printUSB}>Print USB</button> */}
    </div>
  );
};
